/* components/PushPuente.js -- EL PUENTE ENTRE EL TOQUE DE UNA NOTIFICACION Y EL ROUTER (#464).
 *
 * El toque llega a `lib/push.js`, que vive fuera de React y no tiene `navigate`. Este
 * componente, montado dentro del `BrowserRouter` junto a `NotificationListener`, se lo
 * presta; si el toque llego antes (app matada), `registrarNavegador` lo atiende al montar.
 * No pinta nada. En web el `navigate` se presta igual y nadie lo usa: sin shell nativo no
 * hay escucha del plugin.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { registrarNavegador } from '../lib/push';

export default function PushPuente() {
  const navigate = useNavigate();
  useEffect(() => registrarNavegador(navigate), [navigate]);
  return null;
}
